<template>
	<li
		:class="['text-sm',
			isVisible ? 'opacity-100' : 'opacity-0',
			isValid ? 'text-(--ui-success)' : 'text-(--ui-error)',
			'transition-opacity duration-1000 ease-in-out',
			{ hidden: isHidden }]"
	>
		<span
			v-if="isValid"
			class="text-(--ui-success)"
		>
			&#x2714;
		</span>
		<span
			v-else
			class="text-(--ui-error)"
		>
			&#x274c;
		</span>
		{{ text }}
	</li>
</template>

<script setup lang="ts">
const props = defineProps({
	text: {
		type: String,
		default: ''
	},
	isValid: {
		type: Boolean,
		default: false
	}
})

const { isValid } = toRefs(props)

const isVisible = ref(true)
const isHidden = ref(false)
const timeout = ref<ReturnType<typeof setTimeout> | null>(null)

watch(isValid, val => {
	if (!val) {
		if (timeout.value) {
			clearTimeout(timeout.value)
		}
		isVisible.value = true
		isHidden.value = false
	} else {
		isVisible.value = false
		timeout.value = setTimeout(() => {
			isHidden.value = true
		}, 1000)
	}
}, {
	immediate: true
})
</script>
